export interface IReplenishmentRequestsResponse {
  items: IReplenishmentRequest[];
  totalRows: number;
  page: number;
  perPage: number;
  totalPages: number;
}

export interface IReplenishmentRequest {
  uuid: string;
  requestNumber: string;
  companyUuid: string;
  amount: string;
  currency: string;
  purpose: string;
  status: IReplenishmentStatusEnum;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  company: IReplenishmentCompany;
  invoiceFileUuid: string;
  invoiceNumber: string;
}

export interface ReplenishmentRequestsFilterModel {
  status?: IReplenishmentStatusEnum;
  startDate?: string;
  endDate?: string;
  page: number;
  per_page: number;
}

export enum IReplenishmentStatusEnum {
  Pending = 'pending',
  Generated = 'generated',
  Sent = 'sent',
  Confirmed = 'confirmed',
  Rejected = 'rejected',
  Cancelled = 'cancelled',
}

export const IReplenishmentStatusMap = {
  [IReplenishmentStatusEnum.Pending]: 'REPLENISHMENT_REQUEST_PENDING_STATUS',
  [IReplenishmentStatusEnum.Generated]: 'REPLENISHMENT_REQUEST_GENERATED_STATUS',
  [IReplenishmentStatusEnum.Sent]: 'REPLENISHMENT_REQUEST_SENT_STATUS',
  [IReplenishmentStatusEnum.Confirmed]: 'REPLENISHMENT_REQUEST_CONFIRMED_STATUS',
  [IReplenishmentStatusEnum.Rejected]: 'REPLENISHMENT_REQUEST_REJECTED_STATUS',
  [IReplenishmentStatusEnum.Cancelled]: 'REPLENISHMENT_REQUEST_CANCELLED_STATUS',
};

export interface IReplenishmentInvoiceRes {
  invoiceFileUuid: string;
  invoiceNumber: string;
  invoiceDate: string;
  amount: string;
  vatRate: number;
  vatAmount: string;
  totalAmount: string;
  vatEnabled: boolean;
}

export interface IReplenishmentCompany {
  uuid: string;
  bin: string;
  name: string;
  legalAddress: string;
}

export interface IReplenishmentSentRes {
  requestUuid: string;
  invoiceNumber: string;
  status: string;
  results: IReplenishmentSentResults[];
}

export interface IReplenishmentSentResults {
  channel: string;
  success: boolean;
  error: string;
}
